import {Component, OnInit} from '@angular/core';
import {IProduct} from "../../../product/product-models";
import {LandingService} from "../../../landing/landing.service";
import {BaseComponent} from "../../../base.component";
import {UserService} from "../../../common/user.service";
import {LoggerService} from "../../../common/logger.service";

@Component({
    selector: 'featured-products-row',
    templateUrl: './featured-products-row.component.html',
    styleUrls: ['./featured-products-row.component.scss'],
    standalone: false
})
export class FeaturedProductsRowComponent extends BaseComponent implements OnInit {

    products: IProduct[];
    titleTag: string = "cart.landing.featured.products";
    showAiMessage: boolean = false;

    constructor(
        private landingService: LandingService,
        userService: UserService,
        loggerService: LoggerService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.getProducts();
    }

    getProducts(): void {
        this.landingService.getLandingProducts().subscribe((data: IProduct[]) => {
            this.products = data;
        });
    }
}
